// extracted by mini-css-extract-plugin
export default {"controlHeader":"NoteList_controlHeader__6Ifve","noteList":"NoteList_noteList__a9CVV","tags":"NoteList_tags__F30uT"};